import { get, remove } from "api/base";

/**
 * @summary - Returns a list of the available youtube live braodcasts for a specific credential
 */
export const getYoutubeLiveBroadcasts = async (socialCredentialId: string) => {
    const { data } = await get(
        `ws/tools/youtube/upcominglivebroadcasts/${socialCredentialId}`
    );
    return data;
};

/**
 * @summary - Returns a list of youtube playlists for a specific credential
 */
export const getYoutubePlaylists = async (socialCredentialId: string) => {
    const {
        data: { playlists }
    } = await get(`/ws/tools/youtube/playlists/${socialCredentialId}`);
    return playlists;
};

/**
 * @summary - Returns a list of youtube content owners for a specific credential
 */
export const getYoutubeContentOwners = async (
    userId: string,
    socialCredentialId: string
): Promise<
    {
        name: string;
        id: string;
    }[]
> => {
    try {
        const {
            data: { contentOwners }
        } = await get(
            `/ws/youtubetools/users/${userId}/socialcreds/${socialCredentialId}/contentowners`
        );
        return contentOwners;
    } catch (e) {
        console.error(`Failed to get Youtube Content owners`, e);
        return [];
    }
};

/**
 * @summary - Delete youtube content owners for a specific credential
 */
export const deleteYoutubeContentOwners = async (
    userId: string,
    socialCredentialId: string
) => {
    try {
        const { data } = await remove(
            `/ws/youtubetools/users/${userId}/socialcreds/${socialCredentialId}/contentowners`
        );
        return data;
    } catch (e) {
        console.error(`Failed to delete Youtube Content owners`, e);
        return [];
    }
};

/**
 * @summary - Returns a list of monetization policies for a given content owner
 */
export const getYoutubePolicies = async (
    userId: string,
    socialCredentialId: string,
    contentOwnerId: string
): Promise<
    {
        name: string;
        id: string;
    }[]
> => {
    const {
        data: { policies }
    } = await get(
        `/ws/youtubetools/users/${userId}/socialcreds/${socialCredentialId}/contentowners/${contentOwnerId}/policies`
    );
    return policies;
};
